var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eachars-box weekAnalysis"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('span',{staticClass:"eachars-title"},[_vm._v("周数据统计")])])],1),_c('div',{style:({width: '100%', height: '300px'}),attrs:{"id":"weekAna"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }